import { getTheme } from '@/lib/theme'
import { Loader as AnatomicLoader } from '@te-whatu-ora/anatomic'
import { Loading03Icon } from '@hugeicons/core-free-icons'
import { HugeiconsIcon } from '@hugeicons/react'
import { useEffect } from 'react'
import { Show } from '../show'

export interface LoaderProps {
  message: string
}

export function Loader({ message }: LoaderProps) {
  useEffect(() => {
    document.getElementById('loader')?.focus()
  }, [])

  const theme = getTheme()

  return (
    <div
      id='loader'
      className='loader'
      aria-label='submitting information'
      aria-live='assertive'
      // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
      tabIndex={0}
    >
      <div className='text-muted-foreground flex items-center justify-center gap-2 text-sm'>
        <Show
          when={theme === 'clinical'}
          fallback={<AnatomicLoader message={message} />}
        >
          <HugeiconsIcon
            icon={Loading03Icon}
            strokeWidth={2}
            className='size-5 animate-spin'
          />
          {message}
        </Show>
      </div>
    </div>
  )
}
